import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
import styles from './PureLink.module.scss';
const PureLink = forwardRef(({ children, className, disabled = false, internal = false, useDefaultStyle = true, ...restLinkProps }, ref) => (_jsx("a", { rel: internal ? 'noopener' : 'noopener noreferrer nofollow', className: classnames({ [styles.pureLink]: useDefaultStyle }, className), ref: ref, "aria-disabled": disabled, ...restLinkProps, children: children })));
PureLink.displayName = PureLink.name;
export { PureLink };
